import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import { FIELD_COLUMNS, type FieldColumns } from '../types'

type Props = { value: FieldColumns; onChange: (columns: FieldColumns) => void; label?: string }

export function ColumnsPicker({ value, onChange, label }: Props) {
  const { t } = useTranslation()
  return (
    <div role="radiogroup" aria-label={label ?? t('hr.belgeler.right.layout')} className="grid grid-cols-3 gap-1 rounded-lg border bg-muted/40 p-1">
      {FIELD_COLUMNS.map((columns) => {
        const checked = value === columns
        return (
          <button
            key={columns}
            type="button"
            role="radio"
            aria-checked={checked}
            onClick={() => onChange(columns)}
            className={cn(
              'flex min-w-0 flex-col items-center gap-1 rounded-md px-1.5 py-1.5 text-[11px] font-medium transition-colors',
              checked ? 'bg-card text-primary shadow-xs ring-1 ring-primary/20' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <span aria-hidden className="flex w-8 gap-0.5">
              {Array.from({ length: columns }, (_, i) => (
                <span key={i} className={cn('h-2 flex-1 rounded-[2px]', checked ? 'bg-primary' : 'bg-muted-foreground/40')} />
              ))}
            </span>
            <span className="truncate">{t(`hr.belgeler.right.columns.${columns}`)}</span>
          </button>
        )
      })}
    </div>
  )
}
